import React, { useState } from "react";
import {
    EuiFormRow,
    EuiFieldText,
    EuiSuperSelect,
    EuiHealth,
    EuiFlexGroup,
    EuiFlexItem,
} from "@elastic/eui";
import { FormattedMessage, useIntl } from "react-intl";
import _ from "lodash";
import ConfirmationModal from "../../../shared/modals/ConfirmationModal";
import { useSelector } from "react-redux";
import { getUserRoles } from "modules/auth/slice";


const defaultCancelledByOptions = [
    {
        value: "illa",
        inputDisplay: (
            <EuiHealth
                color="primary"
                style={{ lineHeight: "inherit" }}
            >
                <FormattedMessage id="misc.illa" />
            </EuiHealth>
        ),
    },
    {
        value: "client",
        inputDisplay: (
            <EuiHealth
                color="warning"
                style={{ lineHeight: "inherit" }}
            >
                <FormattedMessage id="misc.client" />
            </EuiHealth>
        ),
    },
];
const supplierPartnerCancelledByOptions = [
    {
        value: "supplier",
        inputDisplay: (
            <EuiHealth
                color="primary"
                style={{ lineHeight: "inherit" }}
            >
                <FormattedMessage id="misc.supplierPartner" />
            </EuiHealth>
        ),
    },
    {
        value: "supplier_client",
        inputDisplay: (
            <EuiHealth
                color="warning"
                style={{ lineHeight: "inherit" }}
            >
                <FormattedMessage id="misc.supplierPartnerClient" />
            </EuiHealth>
        ),
    },
];



function TripActionModal({
    action,
    completionActionPreview,
    tripCancellationReason,
    tripCancelledBy,
    onConfirm,
    onCancel,
}) {
    const getCurrentUserRoles = useSelector(getUserRoles());
    const isUserSupplierPartner = getCurrentUserRoles?.includes("supplier_partner_account_manager")

    const cancelledByOptions = isUserSupplierPartner ? supplierPartnerCancelledByOptions : defaultCancelledByOptions


    const cancelledByOption = (cancelledByOptions).filter((co) => co.value === tripCancelledBy);
    const [cancellationReason, setCancellationReason] = useState(tripCancellationReason);
    const [cancelledBy, setCancelledBy] = useState(
        (cancelledByOption && cancelledByOption[0]?.value) || cancelledByOptions[0].value
    );
    const intl = useIntl();
    const onCancellationTextChange = (e) => {
        setCancellationReason(e.target.value);
    };

    const onCancelledBySelect = (e) => {
        setCancelledBy(e);
    };

    const renderCancellationReasonForm = () => (
        <>
            <p>
                {intl.formatMessage({
                    id: "trip-actions.cancellation-reason-title",
                })}
            </p>
            <EuiFlexGroup style={{ maxWidth: 600 }}>
                <EuiFlexItem>
                    <EuiFormRow
                        label={intl.formatMessage({
                            id: "trip-actions.cancellation-reason-label",
                        })}
                    >
                        <EuiFieldText
                            name="cancellationReason"
                            placeholder={intl.formatMessage({
                                id: "trip-actions.cancellation-reason-placeHolder",
                            })}
                            value={cancellationReason}
                            onChange={(e) => onCancellationTextChange(e)}
                        />
                    </EuiFormRow>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiFormRow
                        label={intl.formatMessage({
                            id: "trip-actions.cancellation-by-label",
                        })}
                    >
                        <EuiSuperSelect
                            options={cancelledByOptions}
                            valueOfSelected={cancelledBy}
                            onChange={(value) => onCancelledBySelect(value)}
                        />
                    </EuiFormRow>
                </EuiFlexItem>
            </EuiFlexGroup>
        </>
    );

    const renderModalBody = () => (
        <>{intl.formatMessage({ id: "trip-actions.change-status-confirmation-body" })}</>
    );

    const renderCompletionPreview = () => (
        <>
            {completionActionPreview.split("\n").map((item, idx) => {
                const [label, value] = item.split(": ");
                return (
                    <span key={idx}>
                        {label}: <b>{value}</b>
                        <br />
                    </span>
                );
            })}
        </>
    );

    const handleConfirmation = () => {
        onConfirm({ cancellationReason, cancelledBy });
    };

    const actionVerb = {
        complete: "completed",
        cancel: "canceled",
        not_requested: "not requested",
        unfulfilled: "unfulfilled",
        not_loaded: "not loaded",
        absent: "absent",
    }[action];

    const actionText = intl.formatMessage({ id: `trip.status-${_.kebabCase(actionVerb)}` });

    return (
        <ConfirmationModal
            title={
                <>
                    {intl.formatMessage(
                        { id: "trip-actions.change-status-confirmation-title" },
                        { status: actionText }
                    )}
                </>
            }
            content={
                (action === "cancel" && renderCancellationReasonForm()) ||
                (action === "complete" && renderCompletionPreview()) ||
                renderModalBody()
            }
            onConfirm={handleConfirmation}
            confirmButtonText={intl.formatMessage({ id: "misc.ok" })}
            onCancel={onCancel}
        />
    );
}

export default TripActionModal;
